
import * as TX from 'app/calcs/Accountant/Transactions/interfaces'
import { ILocal697PensionInputs } from 'app/calcs/customers/local697/interfaces'
import { CommonPensionCalculations } from 'app/calcs/pensions'
import { IMonthlyPensionPayments, SimplePensionFormOfPayment } from 'app/calcs/pensions/interfaces'
import { cachedLocal697RunCalculations } from 'app/redux/Customers/local697/actions'
import { ageAtAsDuration, IRetirementPerson, Profile } from 'app/redux/Profile/model'
import { WorkbookServiceResponse } from 'app/redux/SSA/actions';
import { ILocal697PlanPInfo, makePlanPMiscExtractor, makePlanPPaymentExtractor } from 'app/workbookDAOs/local697DAO'
import * as _ from 'lodash'
import * as moment from 'moment'

const markNoExport = (tx: TX.ITransactionItem): TX.ITransactionItem => {
  tx.doNotExport = true
  return tx
}

class Local697PlanPPensionCalculations extends CommonPensionCalculations<ILocal697PensionInputs> {

  public info: ILocal697PlanPInfo
  private spouse: IRetirementPerson

  constructor(profile: Profile, name: string = 'Plan P') {
    super(profile, name, 'planPPaymentsAge')
  }

  getMonthlyPensionAmount(member: IRetirementPerson, vals: ILocal697PensionInputs, when: moment.Moment): Promise<IMonthlyPensionPayments> {
    const spouse = this.spouse
    const shared = this.profile.pension.shared
    const ioInputs = this.profile.pension.IO
    const nebfInputs = this.profile.pension.NEBF
    return cachedLocal697RunCalculations({ member, spouse, vals, ioInputs, nebfInputs, shared, when: null })
      .then((wr) => {
        this.info = makePlanPMiscExtractor()(wr)
        const ex1 = makePlanPPaymentExtractor(vals, when)
        const baseAmount = ex1(wr)
        const kind = vals.formOfPayment as SimplePensionFormOfPayment
        // tslint:disable-next-line:no-debugger
        //debugger
        const r = {
          amount: ex1(wr),
          kind: vals.formOfPayment,
          beginPaymentsAge: ageAtAsDuration(member, when),
          totalLumpSum: 0,
          totalVestingService: 0,
          totalPensionCredits: 0
        }
        // tslint:disable-next-line:no-console
        //console.log('getMonthlyPensionAmount: ' + JSON.stringify(r))
        return r
      })
  }

  getPension(): ILocal697PensionInputs {
    return this.profile.pension.local697
  }

  getPerson(): IRetirementPerson {
    return this.profile.getHeadOfHousehold()
  }

  getTimeLineTransactions(): Promise<TX.ITransactionItem[]> {
    this.setSpouse(this.profile.getSpouse())
    return super.getTimeLineTransactions()
    .then((txs) => _.map(txs, markNoExport))
  }

  getTransactions(when: moment.Moment, tolerance: TX.TransactionTolerance = 'month'): Promise<TX.ITransactionItem[]> {
    this.setSpouse(this.profile.getSpouse())
    return super.getTransactions(when, tolerance)
    .then((txs) => _.map(txs, markNoExport))
  }

  setSpouse(spouse: IRetirementPerson) {
    this.spouse = spouse
  }
}

export {
  Local697PlanPPensionCalculations
}



// WEBPACK FOOTER //
// ./src/app/calcs/customers/local697PlanP/index.ts